import React, { useEffect, useState } from 'react';
import {Translate, useTranslation} from '../../../../config/TranslationProvider';
import ListingActionButton from '../../../partials/ListingActionButton';
import EventsFilter from '../../../filter/EventsFilter';
import classNames from 'classnames';
import BackDrop from '../../../partials/BackDrop';
import { useWindowWidth } from '../../../../helper';
import config from '../../../../config/config';

const EventsListingHeader = ({events, listType, setListType, tags, categories, onSubmit, filter, fixedFilter}) => {
    const [showFilter, setShowFilter] = useState(false);
    const [showBackDrop, setShowBackDrop] = useState(false);
    const {breakpoints} = config;

    const [size] = useWindowWidth();
    useEffect(() => {
        if (size < breakpoints.sm && listType === 'grid') {
            setListType('list');
        }
    }, [size, listType, setListType, breakpoints]);

    const closeFilterDropdown = () => {
        setShowFilter(false);
        setShowBackDrop(false);
    };

    const filterForm = (
        <>
            <EventsFilter
                tags={tags}
                categories={categories}
                onSubmit={onSubmit}
                filter={filter}
                fixedFilter={fixedFilter}
            />
            <button onClick={closeFilterDropdown} className="close-filter-dropdown">
                <i className="la la-times" />
            </button>
            {showBackDrop && <BackDrop click={closeFilterDropdown} breakpoints="backdrop-for-xs" />}
        </>
    );

    return (
        <div className="atbd_generic_header">

            {/* Left side */}
            <div className="filter-dropdown">
                <div className={classNames({
                    dropdown: true,
                    show: showFilter,
                })}>
                    <button
                        id="filterDropdown"
                        type="button"
                        className="open_filter_btn"
                        aria-haspopup="true"
                        aria-expanded={showFilter}
                        aria-label={useTranslation('filter_open_close')}
                        onClick={e => {
                            e.target.blur();

                            setShowFilter((prevState) => !prevState);
                            setShowBackDrop((prevState) => !prevState);
                        }}
                    >
                        <span className="la la-filter la-2x" />
                    </button>
                    <div aria-labelledby="filterDropdown" className={classNames({
                        'dropdown-menu': true,
                        show: showFilter,
                    })}>
                        {filterForm}
                    </div>
                </div>
            </div>
            <div>
                <h2>
                    <Translate value="events" />
                </h2>
                <p>
                    <Translate value="results" /> {events.total_count}
                </p>
            </div>

            {/* Right side */}
            <div className="atbd_listing_action_btn btn-toolbar" role="toolbar">

                {/* Right side */}
                <div className="atbd_listing_action_btn btn-toolbar" role="toolbar">
                    {/* List button */}
                    <ListingActionButton btnType="list" listType={listType} setListType={setListType} />
                    {/* Grid button */}
                    <ListingActionButton btnType="grid" listType={listType} setListType={setListType} />
                    {/* Map Button */}
                    <ListingActionButton btnType="map" listType={listType} setListType={setListType} />
                </div>

            </div>

        </div>
    );
};

export default EventsListingHeader;
